import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function Anexo30Y31Ano2022ProgramaInformatico() {
  return <CategoryPage category="anexo30Y31Ano2022ProgramaInformatico" pageTitle="Programa Informatico 2022" />;
}

export default Anexo30Y31Ano2022ProgramaInformatico;
